import { render, staticRenderFns } from "./budget-event-gu.vue?vue&type=template&id=ecd4fa72&scoped=true&"
import script from "./budget-event-gu.vue?vue&type=script&lang=ts&"
export * from "./budget-event-gu.vue?vue&type=script&lang=ts&"
import style0 from "./budget-event-gu.vue?vue&type=style&index=0&id=ecd4fa72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd4fa72",
  null
  
)

export default component.exports